import React from 'react'
import { Control, Controller, useForm } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { ISelectProposalForm } from '../../modal-select-proposal.types'
import { Button, BUTTON_COLOR, BUTTON_WEIGHT } from '../../../../atoms'
import { InputText } from '../../../input-text'
import Modal from '../../../modal/Modal'

interface IProposalClientRequestCreateProjectModalProps {
  isOpen: boolean
  onRequestClose: () => void
  className?: string
  control: Control<ISelectProposalForm, any>
  onClick: () => void
}

interface INewProjectForm {
  briefTitle: string
}

const ProposalClientRequestCreateProjectModal = ({
  isOpen,
  onRequestClose,
  control,
  onClick,
}: IProposalClientRequestCreateProjectModalProps) => {
  const intl = useIntl()
  const {
    control: newProjectControl,
    watch,
    getValues,
  } = useForm<INewProjectForm>({
    mode: 'onChange',
    defaultValues: {
      briefTitle: '',
    },
  })

  return (
    <Modal
      isOpen={isOpen}
      title={intl.formatMessage({
        id: 'ui.ProposalClientRequestCreateProjectModal.createNewProject',
        defaultMessage: 'Créer un nouveau projet',
      })}
      closeModal={onRequestClose}
      styleHeader={{ borderBottom: '1px solid var(--border)' }}
      style={{ width: '40%', zIndex: 999999999 }}
      renderButtons={() => (
        <div className={s.footer}>
          <Button
            onClick={onRequestClose}
            weight={BUTTON_WEIGHT.FILLED}
            color={BUTTON_COLOR.LIGHT_GREY}
          >
            <FormattedMessage
              id='ui.ProposalClientRequestCreateProjectModal.cancel'
              defaultMessage='Annuler'
            />
          </Button>
          <Controller
            name='briefTitle'
            control={control}
            render={({ field }) => (
              <Button
                onClick={() => {
                  field.onChange(getValues('briefTitle'))
                  onClick()
                }}
                type='submit'
                disabled={watch('briefTitle') === ''}
                weight={BUTTON_WEIGHT.FILLED}
                data-testid='submit-project-button'
              >
                <FormattedMessage
                  id='ui.ProposalClientRequestCreateProjectModal.confirm'
                  defaultMessage='Confirmer'
                />
              </Button>
            )}
          />
        </div>
      )}
    >
      <div className={s.content}>
        <span>
          <FormattedMessage
            id='ui.ProposalClientRequestCreateProjectModal.projectName'
            defaultMessage='Nom du projet'
          />
        </span>
        <InputText
          control={newProjectControl}
          name='briefTitle'
          rules={{
            required: intl.formatMessage({
              id: 'ui.ProposalClientRequestCreateProjectModal.requiredProjectName',
              defaultMessage: 'Le nom du projet est obligatoire',
            }),
          }}
          placeholder={intl.formatMessage({
            id: 'ui.ProposalClientRequestCreateProjectModal.enterHere',
            defaultMessage: 'Écrire ici',
          })}
          labelProps={{
            className: s.label,
          }}
          inputProps={{
            className: s.input,
          }}
          dataTestId='project-name-input'
        />
      </div>
    </Modal>
  )
}

export default ProposalClientRequestCreateProjectModal
